<template>
    <div class="modal fade" id="classAttachments" tabindex="-1" aria-labelledby="classAttachments" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="exampleModalLabel">Material de estudo da aula</h1>
                    <button
                        @click="emits('close')"
                        type="button" 
                        class="btn-close" 
                        data-bs-dismiss="modal" 
                        aria-label="Close">
                    </button>
                </div>
                <div class="modal-body">
                    <div v-if="loading" class="text-center">
                        <p class="fs-4">Carregando... <i class="fa fa-spin fa-spinner fs-4"></i></p>
                    </div>
                    
                    <div v-else-if="error" class="alert alert-danger">
                        {{ error }}
                    </div>
                    
                    <div v-else-if="attachments.length === 0" class="text-center">
                        Nenhum anexo disponível.
                    </div>
                    
                    <ul v-else class="list-group">
                        <li v-for="attachment in attachments" :key="attachment.id" class="list-group-item d-flex justify-content-between align-items-center">
                            <a :href="attachment.url" 
                               target="_blank" 
                               class="text-decoration-none">
                                {{ attachment.description }}
                            </a>
                            <span class="badge bg-primary rounded-pill">{{ attachment.type !== 'link' ? 'Arquivo' : 'Link'  }}</span>
                        </li>
                    </ul>
                </div>
                <div class="modal-footer">
                    <button 
                        type="button" 
                        class="btn btn-secondary" 
                        data-bs-dismiss="modal" 
                        aria-label="Close" 
                        @click="emits('close')">
                        Fechar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { onMounted, ref, watch } from 'vue';
    import axios from 'axios';

    interface Attachment {
        id: number;
        class_id: number;
        description: string;
        type: string;
        value: string;
        url: string;
    }

    const props = defineProps({
        show: {type: Boolean, required: true},
        url: {type: String, required: true},
    })

    let modal: any = null;

    const attachments = ref<Attachment[]>([]);
    const loading = ref(false);
    const error = ref<string | null>(null);

    const emits = defineEmits<{
        (e: 'close'): void;
    }>();

    async function getAttachments() {
        try {
            loading.value = true;
            error.value = null;
            
            const response = await axios.get(props.url);

            attachments.value = response.data;
        } catch (err) {
            console.error('Error fetching attachments:', err);
            error.value = 'Erro ao carregar os anexos';
        } finally {
            loading.value = false;
        }
    }

    onMounted(() => {
        //@ts-ignore
        modal = new bootstrap.Modal('#classAttachments');

        watch(() => props.show, (value) => {
            if(value) {
                modal.show();
                getAttachments();
            }
            else {
                modal.hide();
            }
        }, {immediate: true})
    })
</script>
